import * as React from "react";
import { AuthPage as MuiAuthPage, AuthProps } from "@refinedev/mui";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

import { SponsorsBanner } from "components/banners";
import Title from "components/Title";

const authWrapperProps = {
  style: {
    backgroundImage: "url('/bg.png')",
    backgroundRepeat: "repeat-x",
  },
};

const contentProps = {
  style: {
    backgroundColor: "#fff",
    border: "1px solid #f5f5f5",
    borderRadius: "16px",
    boxShadow: "4px 8px 16px rgba(42, 42, 66, 0.25)",
    width: "384px",
    padding: "0",
  },
};

const renderAuthContent = (content: React.ReactNode) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Link to="/" style={{ marginBottom: "32px", textDecoration: "none" }}>
        <Title />
      </Link>
      {content}
      <SponsorsBanner />
    </div>
  );
};

export const AuthPage: React.FC<AuthProps> = ({ type, formProps, ...rest }) => {
  return (
    <MuiAuthPage
      type={type}
      wrapperProps={authWrapperProps}
      contentProps={contentProps}
      renderContent={renderAuthContent}
      formProps={formProps}
      {...rest}
    />
  );
};
